import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 88 88"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m83.806 26.661-6.198-8.433 3.706-10.261a1 1 0 0 0-1.28-1.28L69.77 10.392 61.34 4.194a1 1 0 0 0-1.592.793l-.133 10.762-8.955 6.442a1 1 0 0 0 .308 1.773l10.147 2.922 2.922 10.147a1.001 1.001 0 0 0 .79.71 1.014 1.014 0 0 0 .171.014 1 1 0 0 0 .812-.416l6.442-8.955 10.762-.133a1 1 0 0 0 .793-1.592Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m53.337 26.728-42.63 39.565 11 11 39.565-42.631-1.774-6.16-6.161-1.774zM6.623 70.084A7.996 7.996 0 0 0 11.993 84q.103 0 .207-.003a7.897 7.897 0 0 0 5.708-2.61l2.438-2.627L9.241 67.655Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }